import * as React from "react"
import { LoggedRedirect } from "@digits-shared/components/Router/LoggedRedirect"
import useRouter from "@digits-shared/hooks/useRouter"
import useSession from "@digits-shared/hooks/useSession"
import { LayoutHeader } from "src/frontend/components/OS/Applications/Home/HomeLayout/LayoutHeader"
import { PortalContent } from "src/frontend/components/OS/Applications/Home/PortalContent"
import { FullScreenScrollableContainer } from "src/frontend/components/OS/Applications/Shared/FullScreenScrollableContainer"
import { Desktop } from "src/frontend/components/Shared/Responsive/Desktop"
import { Mobile } from "src/frontend/components/Shared/Responsive/Mobile"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"
import type FrontendSession from "src/frontend/session"

/*
 COMPONENTS
*/

export const HomeLayout: React.FC<React.PropsWithChildren> = () => {
  const { isSharingContextActive, hasDashboardLegalEntityOrAffiliation, currentLegalEntity } =
    useSession<FrontendSession>()
  const { search } = useRouter()
  const generatePath = useFrontendPathGenerator()

  if (!currentLegalEntity) return null

  if (search.has("intervalCount") || search.has("highlight")) {
    return (
      <LoggedRedirect
        name="home-removeIntervalCount"
        to={generatePath(routes.legalEntityHome, {}, "includeAllQueryParams", [
          "intervalCount",
          "highlight",
        ])}
      />
    )
  }

  /* Need to ensure a legal entity to handle loading support for Digits Employees */
  if (!hasDashboardLegalEntityOrAffiliation || isSharingContextActive) {
    return null
  }

  return (
    <>
      <Desktop>
        <LayoutHeader />

        <FullScreenScrollableContainer fullWidth>
          <PortalContent />
        </FullScreenScrollableContainer>
      </Desktop>

      <Mobile>
        <PortalContent />
      </Mobile>
    </>
  )
}
